module.exports = "<div class=\"calendar-item\"\n     ng-style=\"{'height': $ctrl.itemHeight + 'px',\n            'top': $ctrl.itemTop + 'px',\n            'left': $ctrl.itemLeft + '%',\n            'width': $ctrl.itemWidth + '%',\n            'border-color': $ctrl.item.color,\n            'background-color': '{{$ctrl.item.color | color: 'blendWhite': 0.7}}' }\">\n\n    <div ng-transclude></div>\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/calendar/calendar-item.html
// module id = 903
// module chunks = 0